module.exports = __webpack_public_path__ + "static/parade-2020-house33-43fef58d56f441939d26d8508a3aa56f.jpg";